export default function useCompany() {
  return __COMPANY_DATA__;
}
